import React from 'react';

import { Draggable, Droppable } from '@hello-pangea/dnd';

import EmptyState from '@components/Gui/EmptyState';
import { NwAddButton } from '@components/Gui/NwButton';

import { ARTICLE_BLOCK_TYPE_OPTIONS } from '@containers/Art/Articles/Articles.constants';

import ArticleEditorBlock from './ArticleEditorBlock';
import { ArticleBlockAddToolbar, ArticleBlocksList, ArticleColumnRoot } from './ArticleEditorColumn.styles';
import { getArticleBlockDroppableId } from './articleEditorDrawerHelpers';

const ArticleEditorColumn = ({
    column,
    row,
    sortByPositionFn,
    onAddBlock,
    onApplyEmbedMedia,
    onChangeBlockText,
    onChangeBlockTitle,
    onChangeEmbedInput,
    onChangeLinkText,
    onChangeMediaSource,
    onChangeNetwalkModel,
    onOpenMediaSelector,
    onRemoveBlock,
    onSelectUploadedMedia,
    onUploadFileEnd,
    onUploadMediaEnd,
    uploadedSelectorZIndex,
}) => {
    const columnBlocksSorted = sortByPositionFn(column.Blocks);
    const blockDroppableId = getArticleBlockDroppableId(row.ID, column.ID);

    return (
        <ArticleColumnRoot key={column.ID}>
            <ArticleBlockAddToolbar>
                {ARTICLE_BLOCK_TYPE_OPTIONS.map((option) => (
                    <NwAddButton
                        ghost
                        key={option.value}
                        label={option.label}
                        lowercase
                        onClick={() => onAddBlock(row.ID, column.ID, option.value)}
                    />
                ))}
            </ArticleBlockAddToolbar>
            <Droppable droppableId={blockDroppableId}>
                {(provided, snapshot) => (
                    <ArticleBlocksList
                        ref={provided.innerRef}
                        $isDraggingOver={snapshot.isDraggingOver}
                        {...provided.droppableProps}
                    >
                        {columnBlocksSorted.length ? (
                            columnBlocksSorted.map((block, blockIndex) => (
                                <Draggable
                                    draggableId={`article-block-${block.ID}`}
                                    index={blockIndex}
                                    key={block.ID}
                                >
                                    {(dragProvided, dragSnapshot) => (
                                        <ArticleEditorBlock
                                            block={block}
                                            column={{ ...column, Blocks: columnBlocksSorted }}
                                            dragHandleProps={dragProvided.dragHandleProps}
                                            dragRef={dragProvided.innerRef}
                                            draggableProps={dragProvided.draggableProps}
                                            draggableStyle={dragProvided.draggableProps.style}
                                            isDragging={dragSnapshot.isDragging}
                                            row={row}
                                            onApplyEmbedMedia={onApplyEmbedMedia}
                                            onChangeBlockText={onChangeBlockText}
                                            onChangeBlockTitle={onChangeBlockTitle}
                                            onChangeEmbedInput={onChangeEmbedInput}
                                            onChangeLinkText={onChangeLinkText}
                                            onChangeMediaSource={onChangeMediaSource}
                                            onChangeNetwalkModel={onChangeNetwalkModel}
                                            onOpenMediaSelector={onOpenMediaSelector}
                                            onRemoveBlock={onRemoveBlock}
                                            onSelectUploadedMedia={onSelectUploadedMedia}
                                            onUploadFileEnd={onUploadFileEnd}
                                            onUploadMediaEnd={onUploadMediaEnd}
                                            uploadedSelectorZIndex={uploadedSelectorZIndex}
                                        />
                                    )}
                                </Draggable>
                            ))
                        ) : (
                            <EmptyState message="No objects" />
                        )}
                        {provided.placeholder}
                    </ArticleBlocksList>
                )}
            </Droppable>
        </ArticleColumnRoot>
    );
};

export default ArticleEditorColumn;
